<template>
  <div>
    <Breadcrumb :options="breadcrumb" />
    
    <div class="main-box">
      <div class="btn">
        <el-button class="down_btn" round type="primary" icon="el-icon-download" @click="downLoad">下载当前操作手册</el-button>
      </div>

      <!-- {{ totalPages }} -->
      <el-tabs tab-position="left" @tab-click="handleClick">
        <el-tab-pane v-for="(c, i) in menu" :key="'page' + i" :label="c.name">
          <div class="pdf-box" @scroll="handleScroll">
            <!-- <el-progress class="progress" color="#53a7ff"
              :percentage="Math.floor((c.loadedRatio / c.totalPages) * 100)">
            </el-progress> -->
            <div class="pdf-scale-box">
              <!-- {{ c.loadedRatio }}/{{ c.totalPages }} -->
              <pdf v-for="i in totalPages" :key="i" :src="c.url" :page="i" @page-loaded="c.loadedRatio++"></pdf>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>

      <!-- <div class="progress" v-show="loadedRatio !== 1">
        <el-progress type="circle" :width="70" color="#53a7ff" :percentage="Math.floor(loadedRatio * 100)">
        </el-progress>
        <br>
      </div> -->
      <!-- <div class="left">
        <el-menu :default-active="menuIndex" class="menu" @select="handleSelect">
          <el-menu-item v-for="(c, i) in menu" :key="i" :index="i + ''" :class="[menuIndex === c.path ? 'active' : '']">
            {{ c.name }}
          </el-menu-item>
        </el-menu>

        <el-button class="down_btn" round type="primary" icon="el-icon-download" @click="downLoad">下载当前操作手册</el-button>
      </div>

      <div class="right">
        <router-view></router-view>
        <div class="pdf-box">
          <div class="pdf-scale-box">
            <pdf v-for="i in totalPages" :key="i" :src="selectedUrl" :page="i"></pdf>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import pdf from "vue-pdf"

export default {
  components: { pdf },
  data() {
    return {
      breadcrumb: [
        { name: "帮助中心" },
        { name: "操作手册" },
      ],
      selectedUrl: "/static/风谷TMS用户操作手册2024版（PC端）.pdf",
      menuIndex: '0',
      totalPages: 1,
      menu: [
        {
          name: '系统PC端操作手册',
          path: '/operation/table/0',
          url: '/static/风谷TMS用户操作手册2024版（PC端）.pdf',
          totalPages: 1,
          loadedRatio: 0,
        },
        {
          name: '系统移动端操作手册',
          path: '/operation/table/1',
          url: '/static/风谷TMS用户操作手册2024版（移动端）.pdf',
          totalPages: 1,
          loadedRatio: 0,
        },
        {
          name: '司机操作手册',
          path: '/operation/table/2',
          url: '/static/风谷TMS用户操作手册2024版（司机端）.pdf',
          totalPages: 1,
          loadedRatio: 0,
        },
      ],
      pageHeight: 0,
      tabIdx: 0,
      count: 1,
      step: 5,
    };
  },
  methods: {
    getPageHeight() {
      const page = document.querySelector('.pdf-box')
      // console.log(page.offsetHeight)
      this.pageHeight = page.offsetHeight
    },
    handleScroll(event) {
      const sTop = event.target.scrollTop
      // 处理滚动事件
      // console.log(sTop); // 输出滚动位置
      // console.log(this.menu[this.tabIdx])
      // 滚动到倒数第3页
      if (sTop >= this.pageHeight * (this.totalPages - 3)) {
        console.log('start')
        this.count++
        const num = this.count * this.step
        const o = this.menu[this.tabIdx]
        if (o.totalPages >= num) {
          this.totalPages = num
        } else {
          this.totalPages = o.totalPages
        }
      }
    },
    handleClick({ paneName }) {
      // console.log(paneName);
      this.tabIdx = paneName
      this.count = 1
      // this.
      const o = this.menu[paneName]
      this.selectedUrl = o.url
      this.getNumPages(o)
      // console.log(this.selectedUrl)
    },
    // handleSelect(key) {
    // console.log(key);
    // this.selectedUrl = this.menu[key].url
    // console.log(this.selectedUrl)
    // },
    // getNumPages() {
    //   let loadingTask = pdf.createLoadingTask(this.selectedUrl);
    //   // console.log(loadingTask)
    //   loadingTask.promise.then((pdf) => {
    //     // console.log(pdf)
    //     this.totalPages = pdf.numPages;
    //   }).catch((error) => {
    //     console.error('pdf加载失败', error);
    //   })
    // },
    getNumPages(o) {
      // console.log({ ...o })
      let loadingTask = pdf.createLoadingTask(o.url);
      // console.log(loadingTask)
      loadingTask.promise.then((pdf) => {
        // console.log(pdf)
        o.totalPages = pdf.numPages;
        console.log(o.totalPages)
        const num = this.count * this.step
        if (o.totalPages >= num) {
          this.totalPages = num
        } else {
          this.totalPages = o.totalPages
        }
      }).catch((error) => {
        console.error('pdf加载失败', error);
      })
    },
    downLoad() {
      const a = document.createElement('a');
      a.href = this.selectedUrl;
      const name = (this.selectedUrl.split('/'))[2]
      a.download = name;
      a.click();
    },
  },
  created() {
    this.pdf = require('vue-pdf')
    console.log('获取的pdf', this.pdf)
  },
  mounted() {
    this.getNumPages(this.menu[0])
    this.$nextTick(() => {
      this.getPageHeight()
    })
    // this.menu.map(v => {
    //   this.getNumPages(v)
    // })
  },
};
</script>

<style lang="less" scoped>
.main-box {
  display: flex;
  height: calc(100vh - 150px);
  position: relative;

  >.btn {
    position: absolute;
    left: 27px;
    top: 200px;
    z-index: 99;
  }

  /deep/.el-tabs {
    .el-tabs__header {
      width: 238px;
      margin-right: 200px;

      .el-tabs__nav {
        .el-tabs__active-bar.is-left {
          right: auto;
          left: 0;
          width: 4px;
          height: 56px;
        }

        .el-tabs__item.is-left {
          text-align: center;
          background-color: #fff;
          height: 56px;
          line-height: 56px;
          border-top: 1px solid #F9F9F9;

          &:first-child {
            border: 0 none;
          }
        }
      }

      .el-tabs__nav-wrap.is-left::after {
        width: 0;
      }
    }

    .el-tabs__content {
      height: 100%;
      // overflow-x: auto;
      // overflow-y: hidden;
      // border: 1px solid #707070;
      background-color: #fff;
      flex: 1;

      &::-webkit-scrollbar {
        width: 10px;
        // height: 10px;
      }

      &::-webkit-scrollbar-thumb {
        background-color: #ddd;
        border-radius: 3px;
        cursor: pointer;
      }
    }
  }

  .left {
    width: 238px;
    height: 100%;
    text-align: center;

    /deep/.el-menu-item {
      text-align: center;

      &.is-active {
        position: relative;

        &::before {
          content: '';
          position: absolute;
          height: 100%;
          width: 4px;
          background: #2691FF;
          left: 0;
          top: 0;
        }
      }
    }

    .down_btn {
      margin-top: 25px;
    }
  }

  .right {
    flex: 1;
    display: flex;
    justify-content: center;
    height: calc(100vh - 150px);

  }

  .pdf-box {
    height: calc(100vh - 150px);
    overflow-x: hidden;
    overflow-y: auto;
    position: relative;
    // border: 1px solid #707070;
    // background-color: #fff;

    &::-webkit-scrollbar {
      width: 10px;
      // height: 10px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #ddd;
      border-radius: 3px;
      cursor: pointer;
    }

    .pdf-scale-box {
      width: 860px;

      .progress {
        width: 100%;
        position: fixed;
        top: 0;
        z-index: 999;
      }
    }
  }
}
</style>
